import log from "loglevel";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link, useLocation } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Card,
} from "react-bootstrap";
import Navbar from "Screens_old/Layout/Common/Components/NavBar";
import * as constants from "Constants";
import httpService from "services/httpService";
import HTMLReactParser from "html-react-parser";
import { MultiSelect } from "primereact/multiselect";
import TableComponent from "../../../Programming/Instructor/AllSubmissions/TableComponent";



function IssuesListContainer({ routeProps }) {
  const params = useParams();
  const [lab_Id, setLabID] = useState();
  const [selectedIssueID, setSelectedIssueID] = useState();
  const location = useLocation();
  const url = location.pathname;
  const urlArray = url.split("/");
  const courseId = urlArray[3];
  const [labTitle, setLabTitle] = useState();
  const [activities, setActivities] = useState([]);
  const [Issues, setIssues] = useState([]);
  const [allIssues, setallIssues] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [selectedIssueIDs, setSelectedIssueIDs] = useState([]);
  const [selectedStatus,setSelectedStatus] = useState([]);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({
    unconfirmed: false,
    confirmed: false,
    replyPending: false,
    replySent: false,
    resolved: false,
    all: true,
  });

  const [approvedInstructors, setApprovedInstructors] = useState([]);
  const [selectedInstructor, setSelectedInstructor] = useState("");

  // // Fetch the list of approved instructors
  // useEffect(() => {
  //   const fetchApprovedInstructors = async () => {
  //     try {
  //       const response = await httpService.get(constants.base_url + `/courseware/api/course/${courseId}/all_instructors/?format=json`);
  //       setApprovedInstructors(response.data); // Assuming response.data is an array of approved instructors
  //       log.log("APproved INstructors",approvedInstructors);
  //     } catch (error) {
  //       log.error("Error fetching approved instructors:", error);
  //     }
  //   };

  //   fetchApprovedInstructors();
  // }, [courseId]);

  // Handle dropdown selection
  const handleInstructorChange = (e) => {
    setSelectedInstructor(e.target.value);
  };

  // Handle assignment logic when the "Assign" button is clicked
  const handleAssign = () => {
    // Perform assignment logic here using the selectedInstructor value
    log.log("Assigning issue to instructor with ID:", selectedInstructor);
  };


  const titleTemplate = (rowData) => {
    return (<Link
      as={Link}
      to={{
        pathname: `/courseware/course/${courseId}/content/labs/${lab_Id}/issues/${rowData.id}/reply`,
      }}
      className="pointer"
      id={lab_Id}
      style={{ cursor: "Pointer" }}
    >
      {rowData.title}
    </Link>)
  };


  const assignedToTemplate = (rowData) => {
    if (rowData.assigned_to) {
      return rowData.assigned_to.username;
    }
    return "Not Assigned";
  };

  const statusTemplate = (rowData) => {
    if (rowData.status == 'RS') {
      return "Reply Sent";
    }
    if (rowData.status == 'RP') {
      return "Reply Pending";
    }
    if (rowData.status == 'RES') {
      return "Resolved";
    }
  };

  const activityTemplate = (rowData) => {
    let name = activities.find(
      (activity) => activity.id === rowData.activity_id
    ).name
    return name;
  };

  const columns = [
    {
      header: 'S.No', field: 'index',
      body: (data, options) => options.rowIndex + 1,
    },
    {
      header: 'Roll Number/LDAP', field: 'created_by.username',
    },
    {
      header: 'Issue', field: 'title',
      body: titleTemplate
    },
    { header: 'Date Posted/Modified', field: 'last_modified' },
    {
      header: 'Assigned To', field: 'assigned_to.username',
      body: assignedToTemplate
    },
    {
      header: 'Status', field: 'status',
      body: statusTemplate
    },
    {
      header: 'Activity', field: 'activity.name',
      body: activityTemplate
    },

  ]

const StatusOptions = [
{name:"Reply Pending"},
{name:"Reply Sent"},
{name:"Resolved"}

]



const tableHeader = () => {
    return (
      <div className="flex justify-content-between align-items-center">
        <MultiSelect
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.value)}
          options={StatusOptions}
          optionLabel="name"
          filter
          display="chip"
          placeholder="Select Columns"
          maxSelectedLabels={3}
          style={{ width: "350px" }}
        />
        
      </div>
    );
  };





  const handleCheckboxChangeSelect = (e, issueID) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      // Add issueID to selectedIssueIDs
      setSelectedIssueIDs([...selectedIssueIDs, issueID]);
      // log.log("Selected Issues ", selectedIssueIDs);
    } else {
      // Remove issueID from selectedIssueIDs
      setSelectedIssueIDs(selectedIssueIDs.filter(id => id !== issueID));
      // log.log("Selected Issues ", selectedIssueIDs);
    }

  };

  const AnnouncementsCard = ({ announcements }) => {
    return (
      <div style={{ marginBottom: "10px" }}>
        <Card style={{ border: "1px solid #ccc", borderRadius: "5px", marginLeft: "5px", marginRight: "5px" }}>
          <Card.Header>
            <h2>Announcements</h2>
          </Card.Header>
          <Card.Body>
            {announcements.map((announcement, index) => (
              <div key={index}>
                <div>
                  <p style={{ fontSize: "18px", marginBottom: "15px" }}>
                    {HTMLReactParser(announcement.message)}
                  </p>
                  <div
                    style={{
                      color: "gray",
                      fontSize: "0.8em",
                      marginTop: "0px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {/* Display timestamp */}
                    <div>
                      Posted by: {announcement.created_by.username} -{" "}
                      {new Date(announcement.created_on).toLocaleString()}
                    </div>
                    {/* Edit and delete buttons */}
                    <div>
                      {/* <Button variant="info" className="mr-2">
                        <FaEdit />
                      </Button>
                      <Button style={{ backgroundColor: "red" }}>
                        <RiDeleteBinLine />
                      </Button> */}
                    </div>
                  </div>
                  {/* Edit and delete buttons */}
                </div>
                {index !== announcements.length - 1 && (
                  <hr
                    style={{
                      height: "0.3px",
                      border: "none",
                      backgroundColor: "gray",
                      color: "gray",
                    }}
                  />
                )}
              </div>
            ))}
          </Card.Body>
        </Card>
      </div>
    );
  };
  const statusOptions = [
    { value: 'RES', label: 'Resolved' },
    { value: 'RP', label: 'Reply Pending' },
    { value: 'RS', label: 'Reply Sent' },
  ];

  useEffect(() => {
    setLabID(params.labId);

    if (lab_Id) {
      let statuses = [];
      log.log("SELECTED STATUS",selectedStatus);
      selectedStatus.forEach(selectedStatus1 => {
        // Find the corresponding status option
        const statusOption1 = statusOptions.find(option => option.label === selectedStatus1.name);
        
        // If a matching status option is found, push it to the statuses array
        if (statusOption1) {
          statuses.push(statusOption1.value);
        }
      });
      log.log("stattsiuisusss",statuses);
      
      // if (selectedCheckboxes.unconfirmed) statuses.push("UNC");
      // if (selectedCheckboxes.confirmed) statuses.push("CNF");
      // if (selectedCheckboxes.replyPending) statuses.push("RP");
      // if (selectedCheckboxes.replySent) statuses.push("RS");
      // if (selectedCheckboxes.resolved) statuses.push("RES");

      var queryString =
        statuses.length > 0
          ? "?" + statuses.map((status) => `status[]=${status}`).join("&")
          : "";

      var url = constants.base_url + "/lab/all/" + lab_Id;
      httpService
        .get(url)
        .then((response) => {
          setLabTitle(response.data?.lab?.title);
          setActivities(response.data?.activities);
        })
        .catch((error) => {
          log.log("Error", error);
        });

      url = constants.base_url + "/issues/getIssues/lab/" + lab_Id;
      httpService
        .get(url)
        .then((response) => {
          log.log("Issues in 1 ", response);
          setallIssues(response.data.issues);
          log.log("Issues in 2", Issues);
        })
        .catch((error) => {
          log.log(error);
        });

      url =
        constants.base_url + "/issues/getIssues/lab/" + lab_Id + queryString;
      httpService
        .get(url)
        .then((response) => {
          log.log("Issues in 3 ", response);
          setIssues(response.data.issues);
          log.log("Issues in 4", Issues);
        })
        .catch((error) => {
          log.log(error);
        });

      url = constants.base_url + "/courseware/api/course/" + courseId + "/all_instructors/?format=json";
      httpService
        .get(url)
        .then((response) => {
          log.log("response for approvedInstructors", response);
          for (let i = 0; i < response.length; i++) {
            log.log(response[i]);
          }
          log.log("Approved Instructors", approvedInstructors);

        })
        .catch((error) => {
          log.log(error);
        });
    }
  }, [lab_Id, selectedCheckboxes, selectedIssueID,selectedStatus]);

  useEffect(() => {
    if (lab_Id) {
      const url =
        constants.base_url + "/issues/getIssueAnnouncements/lab/" + lab_Id;
      try {
        httpService.get(url).then((response) => {
          // log.log("Announcements,", response);
          setAnnouncements(response.data);
        });
      } catch (error) {
        log.log("error,", error);
      }
    }
  },[])

  useEffect(() => {
    log.log("Issues in iseeffecr", Issues);

  }, [Issues]);

  // useEffect(() => {
  //     if(lab_Id){
  //         if (selectedIssueID) {
  //             var url = constants.base_url + "/issues/getIssue/" + selectedIssueID;
  //             httpService
  //                 .get(url)
  //                 .then((response) => {
  //                     // log.log(response);
  //                     setSelectedIssue(response.data?.issue);
  //                     log.log(selectedIssue);
  //                     // setStatusOption(response.data?.issue?.status);
  //                     // log.log(selectedIssue);
  //                 })
  //                 .catch((error) => {
  //                     log.log("Error", error);
  //                 })

  //         }
  //     }
  // },[ selectedIssueID ]);

  Issues.sort((a, b) => {
    const dateA = new Date(a.last_modified);
    const dateB = new Date(b.last_modified);

    return dateB - dateA; // Note: 'dateB - dateA' for descending order
  });

  function filterIssues(jsonObj, field, filterString) {
    // log.log("Selected Issues in filter ", selectedIssueIDs);
    const filteredIssues = jsonObj.filter((issue) => {
      return issue[field].toLowerCase().includes(filterString.toLowerCase());
    });

    return filteredIssues;
  }

  const Unconfirmed = filterIssues(allIssues, "status", "UNC");
  const Confirmed = filterIssues(allIssues, "status", "CNF");
  const ReplyPending = filterIssues(allIssues, "status", "RP");
  const ReplySent = filterIssues(allIssues, "status", "RS");
  const Resolved = filterIssues(allIssues, "status", "RES");

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setSelectedCheckboxes((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const showHeaderComponent = () => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginLeft: "10px",
            marginBottom: "20px",
            marginTop: "20",
          }}
        >
          <div style={{ marginRight: "20px" }}>
            <span style={{ fontWeight: "bold" }}>Issues:</span>{" "}
            <Button
              style={{
                border: "none",
                cursor: "default",
                padding: "0.2rem 0.5rem",
                borderRadius: "0.25rem",
              }}
              disabled
            >
              {Issues.length}
            </Button>
          </div>

          <div style={{ marginRight: "20px" }}>
            <span style={{ fontWeight: "bold" }}>Reply Pending:</span>{" "}
            <Button
              style={{
                border: "none",
                cursor: "default",
                padding: "0.2rem 0.5rem",
                borderRadius: "0.25rem",
              }}
              disabled
            >
              {ReplyPending.length}
            </Button>
          </div>
          <div>
            <span style={{ fontWeight: "bold" }}>Reply Sent:</span>{" "}
            <Button
              style={{
                border: "none",
                cursor: "default",
                padding: "0.2rem 0.5rem",
                borderRadius: "0.25rem",
              }}
              disabled
            >
              {ReplySent.length}
            </Button>
          </div>
          <div>
            <span style={{ fontWeight: "bold" }}>Resolved:</span>{" "}
            <Button
              style={{
                border: "none",
                cursor: "default",
                padding: "0.2rem 0.5rem",
                borderRadius: "0.25rem",
              }}
              disabled
            >
              {Resolved.length}
            </Button>
          </div>
        </div>

        
      </div>
    );
  };


  // const getActivityName = async (activity_id) => {
  //     let activity_title = "";
  //     try {
  //         const response = await httpService.get(constants.base_url + "/lab/activity/" + activity_id + '?type=programming');
  //         log.log("Activity title", response.data?.program_data?.name);
  //         activity_title = response.data?.program_data?.name;
  //         log.log(activity_title);
  //     } catch (error) {
  //         log.log("Error", error);
  //     }
  //     return activity_title;
  // };

  return (
    <div class="cont">
      <Navbar navbarClass="navbar-dark fixed-top" />
      <Breadcrumb>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs`}>Labs</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="#">
          <Link to={`/courseware/course/${courseId}/content/labs/${lab_Id}/`}>
            {labTitle}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Issues</Breadcrumb.Item>
      </Breadcrumb>
      <hr
        style={{
          height: "1px",
          border: "none",
          backgroundColor: "grey",
        }}
      />
      <div style={{ padding: "10px" }}></div>
      {showHeaderComponent()}
      {/* <div>
        <DropdownButton title="Select Instructor">
          {Array.isArray(approvedInstructors) && approvedInstructors.map((instructor) => (
            <Dropdown.Item key={instructor.id} onSelect={() => setSelectedInstructor(instructor.id)}>
              {instructor.fullname}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        <Button onClick={handleAssign}>Assign</Button>
      </div> */}
      <div></div>
      
      {/* Include the Announcements card component here */}
      <hr
        style={{
          height: "1px",
          border: "none",
          backgroundColor: "grey",
        }}
      />
      { }
      <div class="table-responsive-sm">
        {/* <table class="table table-striped table-bordered table-hover">
          <thead>
            <th>

            </th>
            <th>
              S.No <span class="arrow-button">&#9660;</span>
            </th>
            <th>
              Roll Number/LDAP <span class="arrow-button">&#9660;</span>
            </th>
            <th>
              Issue <span class="arrow-button">&#9660;</span>
            </th>
            <th>
              Date Posted/ Modified <span class="arrow-button">&#9660;</span>
            </th>
            <th>
              Assigned To <span class="arrow-button">&#9660;</span>
            </th>
            <th>
              Status <span class="arrow-button">&#9660;</span>
            </th>
            <th>
              Activity <span class="arrow-button">&#9660;</span>
            </th>
          </thead>
          <tbody>
            {Issues.map((issue, index) => (
              <tr key={issue.id}>
                <td>
                  
                  <input
                    type="checkbox"
                    checked={selectedIssueIDs.includes(issue.id)}
                    onChange={(e) => handleCheckboxChangeSelect(e, issue.id)}
                  />
                </td>
                <td>{index + 1}</td>
                <td>{issue.created_by.username}</td>
                <td>
                  <Link
                    as={Link}
                    to={{
                      pathname: `/courseware/course/${courseId}/content/labs/${lab_Id}/issues/${issue.id}/reply`,
                    }}
                    className="pointer"
                    id={lab_Id}
                    style={{ cursor: "Pointer" }}
                  >
                    {issue.title}
                  </Link>
                </td>
                <td>{new Date(issue.last_modified).toLocaleString()}</td>
                <td>
                  {issue.assigned_to
                    ? issue.assigned_to.username
                    : "Not Assigned"}
                </td>
                <td>{issue.status}</td>
                <td>
                  {
                    activities.find(
                      (activity) => activity.id === issue.activity_id
                    ).name
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
        <TableComponent
          tableData={Issues}
          columns={columns}
          tableHeader={tableHeader}


        />
      </div>
    </div>
  );
}

export default IssuesListContainer;
